import { roundToTwo } from 'common/helpers/round-to-two.helper';
import { TInputs } from '../forms/dimensions/types';

export const getAreaUser = ({ area, length, width }: TInputs) => {
  if (Number(length) && Number(width)) {
    const res = Number(length) * Number(width);

    return roundToTwo(res);
  }

  return Number(area);
};
